export default "__VITE_ASSET__DrK0krQQ__"